(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodAutocomplete', sodAutocomplete);

    function sodAutocomplete(lodash) {

        return {
            restrict: 'E',
            scope: {
                options: '=',
            },
            // bindToController: true,
            require: 'ngModel',
            templateUrl: 'common/components/sod-autocomplete',
            controller: sodAutocompleteCtrl,
            link: function (scope, elem, attr, ctrl) {
                ctrl.$render = function () {
                    if (ctrl.$viewValue) {
                        scope.currentModel = ctrl.$viewValue;
                    }
                    if (scope.$autocomplete) {
                        scope.$autocomplete.autocomplete('val', scope.currentModel.text);
                    }
                };

                scope.onAcChange = function () {
                    // console.log('test');
                };

                scope.$watch(function () {
                    return (scope.$autocomplete.autocomplete) ? scope.$autocomplete.autocomplete('val') : null;
                }, function () {
                    scope.currentModel.text = scope.$autocomplete.autocomplete('val');
                    // console.log(scope.currentModel);
                    ctrl.$setViewValue(scope.currentModel);
                });
            }
        }
    }

    function sodAutocompleteCtrl($scope, lodash, GenericModel, $element, $templateCache, $compile) {
        var options = {};
        var input_elem;
        var autocomplete_options;
        var $autocomplete;

        this.$onInit = function() {
            options = $scope.options || {};


            // <% vm.options.placeholder || "Type to search" %>

            init();

            $scope.$on('$destroy', function () {
                destroyAutocomplete();
            });

            $scope.testClick = function (data) {
                // console.log('test click', data);
            }
        }


        function init() {
            $scope.currentModel = {
                text: '',
                value: null,
            };
            input_elem = $element.find('input.sod-tagging__input');
            autocomplete_options = lodash.get(options, 'autocomplete', {});
            input_elem.attr('placeholder', lodash.get(options, 'placeholder', 'Type to search'));

            initAutoComplete(autocomplete_options);
            // initAutoCompleteEvents();

            $scope.$autocomplete = $autocomplete;
        }


        function initAutoComplete(autocomplete_options) {
            var options = autocomplete_options; //options seeded in formfields; override here
            var dataset = getDataset();
            $autocomplete = $(input_elem).autocomplete(options, dataset);

            initAutoCompleteEvents($autocomplete)
        }

        function initAutoCompleteEvents($autocomplete) {
            // $autocomplete.on('autocomplete:cursorchanged', function (e, suggestion, dataset, context) {
            //     var $dropdownItem = $(`span.truncate:contains(${suggestion.label})`);
            //     if ($dropdownItem.get(0))
            //         $dropdownItem.get(0).scrollIntoView({
            //             block: "nearest",
            //         });
            // });
        }

        function getDataset() {
            var datasource_option = lodash.get(options, 'datasource', []);
            return datasource_option.map(function (ds) {
                return {
                    source: function (query, cb) {
                        var resource = prepareDsResource(ds);
                        if (!!resource) {
                            resource({query: query}).$promise.then(function (res) {
                                cb(res.data);
                            });
                        } else {
                            cb([]);
                        }
                    },
                    debounce: options.debounce || 400,
                    cache: false,
                    displayKey: lodash.get(options, 'schema.label', 'label'),
                    templates: {
                        suggestion: function (suggestion) {
                            if (lodash.has(suggestion, 'id')) {
                                suggestion.emit = emitEvent;
                                var _template = TemplateEngine(
                                    $templateCache.get(lodash.get(options, 'templateUrl')),
                                    suggestion
                                );
                                return _template;
                            }
                        }
                    }
                }
            });
        }

        function destroyAutocomplete() {
            $autocomplete.autocomplete('destroy');
        };

        function TemplateEngine(html, options) {
            var optionScope = $scope.$new(true);
            optionScope.optionModel = options;
            return $compile(html)(optionScope);

        };

        function prepareDsResource(ds_option) {
            var url = lodash.get(ds_option, 'url', '');
            var method = lodash.get(ds_option, 'method', 'query');
            var resource = (url) ? new GenericModel(url) : null;
            return !!resource ? resource[method] : null;
        }

        function emitEvent(item) {
            // console.log('emit event', item);
            $scope.currentModel.value = item.value;

            var valueKey = lodash.get(options, 'schema.value', 'value');
            var eventName = lodash.get(options, 'event.click', '');
            if (!!eventName) {
                $scope.$emit(eventName, lodash.pick(item, [valueKey]) );
            }
        }
    }
})();